import { get } from "lodash-es"
import { postDrafts } from "../../apis/drafts"
import { getApprobalListByParam } from "../../utils/approval"

const getTask = async ({ mode, defaultData }) => {


  const fields = [
    {
      title: "요청내용",
      key: "title",
      type: "input",
      required: true,
    },
    // {
    //   title: "요청 내용",
    //   key: "content",
    //   type: "textarea",
    //   placeholder: 'ex) 재직증명서를 요청합니다.',
    //   required: true,
    // },
  ]

  // TODO 결재위임 상세
  const defaultForm = {
    title: get(defaultData, 'approvalTarget.title', ""),
    // content: get(defaultData, 'data.draft.content', ""),
  }

  const create = (form) => {

    const params = {
      title: form.title,
      content: form.content,
      type: "certificate_request",
      uploadFiles: form.uploadFiles,
      approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    }

    return postDrafts(params)
  }
  const validate = (form) => {
    let errors = {};
    return errors
  }
  return {
    fields, defaultForm, create, validate
  }
}

export default getTask